var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v(_vm._s(_vm.rod.name))]),_c('h3',[_vm._v(_vm._s(_vm.rod.about))]),_c('persons-list',{attrs:{"persons":_vm.persons}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }